import React, { FC, useCallback, useMemo } from 'react';
import { POSMultiselectDropdown } from '@publicisgroupe/p-os-components';
import { capitalize } from '../../utils/stringUtils';

type Props = {
  label: string;
  options: string[];
  checkedOptions: string[];
  onChange: (newValue: string[]) => void;
  required?: boolean;
  errorMessage?: string;
};

export const StringsMultiselectDropdown: FC<Props> = ({
  label,
  options,
  checkedOptions,
  onChange,
  required,
  errorMessage,
}) => {
  const multiselectOptions = useMemo<
    { label: string; value: string; checked: boolean }[]
  >(() => {
    const multiselectOptions =
      options?.map((o) => {
        return {
          label: o,
          value: o,
          checked: !!checkedOptions?.find((i) => i === o),
        };
      }) || [];

    return multiselectOptions;
  }, [options, checkedOptions]);

  const onSelectHandler = useCallback(
    (selectedValue: string) => {
      if (!!checkedOptions?.find((i) => i === selectedValue)) {
        onChange(checkedOptions.filter((o) => o !== selectedValue));
        return;
      }

      onChange([...checkedOptions, selectedValue]);
    },
    [checkedOptions, onChange]
  );

  return (
    <POSMultiselectDropdown
      required={required}
      error={errorMessage}
      label={capitalize(label)}
      options={multiselectOptions}
      onSelect={onSelectHandler as any}
    />
  );
};
